import { useQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { marketService } from 'shared/src/api';
import type { GetMarketParentGoodsCarouselResponse } from 'shared/src/api/marketService/getMarketParentGoodsCarousel/types';
import { convertMarketHomeGoodsItemToGoodsData } from '../../../utils/convertMarketHomeGoodsItemToGoodsData';
import type { QueryHookOptions } from 'shared/src/types';

export const useParentMarketGoodsCarouselQuery = (
  marketId: number,
  options?: QueryHookOptions<GetMarketParentGoodsCarouselResponse>,
) => {
  return useQuery({
    queryKey: queryKey.marketParentGoodsCarousel(marketId),
    queryFn: () => marketService.getMarketParentGoodsCarousel(marketId),
    staleTime: 0,
    select: (data: GetMarketParentGoodsCarouselResponse) => {
      return {
        ...data,
        components: data.components.map(component => ({
          ...component,
          entity: {
            ...component.entity,
            item_list: component.entity.item_list.map(
              convertMarketHomeGoodsItemToGoodsData,
            ),
          },
        })),
      };
    },
    ...options,
  });
};
